import { formatPhone } from '../../../utility/formatPhone';

export const getCustomerDisplayName = (name) => {
  const text = typeof name === 'string' ? name.trim() : '';
  return text && !/^[#\s\-–—]+$/.test(text) ? text : 'Unknown';
};

const displayPhone = value => formatPhone(value, null);

export const getCustomerDisplayPhone = (profile, conversation, channel = '') => {
  const profilePhone = displayPhone(profile?.phone);
  if (profilePhone) return profilePhone;
  // Platform sender IDs on other channels are not necessarily phone numbers.
  if (!['sip', 'telephony'].includes(channel.toLowerCase())) return null;
  return displayPhone(conversation?.phoneNumber) || displayPhone(conversation?.senderId);
};
